export default __webpack_public_path__ + "static/media/confirmBranch.cdbff759.svg";